<script>
    import DetailsCornerItem from './DetailsCornerItem.svelte'

    import { Container } from '@/components'

    const items = [
        {
            title: 'Система<br/> уведомлений',
            description: 'Получайте сообщения об<br/> изменении в личном кабинете<br/> по электронной почте',
            background: 'linear-gradient(180deg, #FF8625 0%, #EA5B0C 100%), #F3954A',
            boxShadow: '6px 4px 74px rgba(200, 96, 12, 0.42)',
            corner: 'right-top',
            left: 0,
            top: 143
        },
        {
            title: 'Любое количество<br/> пользователей',
            description: 'Подключайте сотрудников без<br/> ограничений по пользовательским<br/> лицензиям со стороны 1С:ЗУП',
            background: 'linear-gradient(0deg, #9454BB 0%, #D187FF 100%), #A461CD',
            boxShadow: '6px 4px 74px rgba(126, 57, 169, 0.63)',
            corner: 'left-bottom'
        },
        {
            title: 'Высокая<br/> производительность',
            description: 'Работаете без перебоев при<br/> большом числе пользователей<br/> и пиковых нагрузках',
            background: 'linear-gradient(180deg, #4A8EF3 0%, #2260BB 100%), #4A8EF3',
            boxShadow: '6px 4px 74px rgba(74, 142, 243, 0.76)',
            corner: 'left-top'
        },
        {
            title: 'Удобная навигация',
            description: 'В интерфейс зашиты быстрые<br/> действия, которые ускорят<br/> работу',
            background: 'linear-gradient(0deg, #9454BB 0%, #D187FF 100%), #A461CD',
            boxShadow: '6px 4px 74px rgba(126, 57, 169, 0.63)',
            corner: 'left-bottom'
        },
        {
            title: 'Локализация',
            description: 'Выбирайте язык — русский<br/> или английский',
            background: 'linear-gradient(180deg, #4A8EF3 0%, #2260BB 100%), #4A8EF3',
            boxShadow: '6px 4px 74px rgba(74, 142, 243, 0.76)',
            corner: 'right-top'
        },
        {
            title: 'Аналитика',
            description: 'Смотрите статистику по рабочим<br/> часам сотрудников, отпускам и<br/> запрошенным справкам',
            background: 'linear-gradient(180deg, #FF8625 0%, #EA5B0C 100%), #F3954A',
            boxShadow: '6px 4px 74px rgba(200, 96, 12, 0.42)',
            corner: 'left-top'
        }
    ]
</script>

<Container>
    <h2 class="title">Продумали EmployeeGate до мелочей, чтобы<br/>
    сделать работу с кадровым документооборотом<br/> 
    удобнее</h2>

    <div class="wrapper scroll-element">
        {#each items as data }
            <DetailsCornerItem {data} />
        {/each}
    </div>
</Container>

<style lang="scss" module>
    .title {
        line-height: 60px;
        text-align: center;
    }

    .wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 60px;
        margin-bottom: 150px;
    }

    @media (max-width: 834px) {
        .title {
            br {
                display: none;
            }
        }
    }

    @media (max-width: 420px) {
        .wrapper {
            display: block;
        }
    }
</style>